import OffboardModal from './OffboardModal'

export default OffboardModal
